import { ComponentPropDefinitions, ComponentPropDefinitionUtil } from "../../base/ComponentProps";
import { PropType } from "../../base/PropType";
import { PanelProps } from "../panel/PanelProps";

export interface LocationProps extends PanelProps {
  caption: string;
  captionVisible: boolean;
  cityField: string;
  stateField: string;
  zipField: string;
  cityIdField: string;
  locationIdField: string;
  printable: boolean;
  printableDuringAdd: boolean;
  printableDuringSearch: boolean;
  printableDuringUpdate: boolean;
}

let locationPropDefs: ComponentPropDefinitions;

export class LocationPropDefinitions {
  public static getDefinitions(): ComponentPropDefinitions {
    if (locationPropDefs == null) {
      locationPropDefs = {
        ...ComponentPropDefinitionUtil.getComponentPropertyDefinitions(),
        caption: { type: PropType.string, description: "This controls the label that appears above the Location component." },
        captionVisible: {
          type: PropType.bool,
          defaultValue: true,
          description: "This toggles whether or not the caption of the Textbox will be shown.  If set to false, there will be no caption or additional whitespace where the caption would normally go."
        },
        cityField: { type: PropType.string, description: "This field to hold the city name." },
        stateField: { type: PropType.string, description: "This field to hold the state." },
        zipField: { type: PropType.string, description: "This field to hold the zip code." },
        cityIdField: { type: PropType.string, description: "This field to hold the city id." },
        locationIdField: { type: PropType.string, description: "This field to hold the location id." },
        locationNameField: { type: PropType.string, description: "This field to hold the location name." },
        addressField: { type: PropType.string, description: "This field to hold the address." },
        searchWebLocation: { type: PropType.bool, description: "Search the web location Lucene index"},
        filterOwner: { type: PropType.bool, description: "Filter results by user logged in"},
        isForStop: { type: PropType.bool, description: "Is this used in a stop table and needs to check against enforce shipper id in dispatch control."},
        printable: {
          type: PropType.bool,
          defaultValue: false,
          category: "Appearance",
          description: "This toggles whether the Location component appears as a caption with a user-editable input box or whether it should be displayed as a caption with a non-editable Label.  This is often changed at runtime.",
        },
        printableDuringAdd: {
          type: PropType.bool,
          defaultValue: false,
          category: "Appearance",
          description: "This toggles whether the Location component should appear in its printable state during add mode.",
        },
        printableDuringSearch: {
          type: PropType.bool,
          defaultValue: false,
          category: "Appearance",
          description: "This toggles whether the Location component should appear in its printable state during search mode.",
        },
        printableDuringUpdate: {
          type: PropType.bool,
          defaultValue: false,
          category: "Appearance",
          description: "This toggles whether the Location component should appear in its printable state during update mode.",
        },
        onChange: { type: PropType.event, category: "Events", addListenerMethod: "addChangeListener", removeListenerMethod: "removeChangeListener", description: "This specifies a function to be called when the value changes." },
        //beforeLookupModelSearch: { type: PropType.event, category: "Events", addListenerMethod: "addBeforeLookupModelSearchListener", removeListenerMethod: "removeBeforeLookupModelSearchListener", description: "This specifies a function to be called before the lookup model is searched, to adjust the filter." },
      };
      ComponentPropDefinitionUtil.populateComponentPropNames(locationPropDefs);
    }
    return locationPropDefs;
  }
}
